import { render, staticRenderFns } from "./TransferTable.vue?vue&type=template&id=21c62fc6&"
import script from "./TransferTable.vue?vue&type=script&lang=js&"
export * from "./TransferTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports